import 
    React 
, { useEffect, useRef }from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from "react-router";
import { Radio } from "antd";

// Constant && Config
import { 
    ROUTES, 
    COMMON_FEATURES 
} from '../../constants'

// Components
import {
    VAMConfigurationManagement,
    VAMEntryManagement,
    VAMReminderManagement,
    VAMVehicleIssuesPanel
} from './components'
import showSecondarySidebar from '../../layout/MainLayout/helpers/showSecondarySidebar'
import Page from "../../components/Decoration/Page"

// Redux Actions
import * as REDUX_ACTIONS from '../../services/redux/actions'

const VAMPanelTab = {
    issues: {
        label: 'Vehicle Issues',
        key: 'issues',
        value: COMMON_FEATURES.FEATURE_NAME.VEHICLE_ISSUES_MANAGEMENT,
        component: <VAMVehicleIssuesPanel />,
    },
    reminder: {
        label: 'Vehicle Reminder',
        key: 'reminder',
        value: COMMON_FEATURES.FEATURE_NAME.VEHICLE_REMINDER_MANAGEMENT,
        component: <VAMReminderManagement />,
    },
    entry: {
        label: 'Service Entry',
        key: 'entry',
        value: COMMON_FEATURES.FEATURE_NAME.VEHICLE_ENTRY_MANAGEMENT,
        component: <VAMEntryManagement />,
    },
    line: {
        label: 'Service Line',
        key: 'line',
        value: COMMON_FEATURES.FEATURE_NAME.VEHICLE_ADVANCE_MAINTENANCE_CONFIGURATION_MANAGEMENT,
        component: <VAMConfigurationManagement />,
    },
}

const VAM = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const routerLocation = useLocation()

    const curUserRole = useSelector(state => state.containers.v3.user && state.containers.v3.user.uroleid)
    const user = useSelector(state => state.containers.v3.user)
    const vehicles = useSelector(state => state.containers.v3.vehicles.stateByID)
    const vids = useSelector(state => state.containers.v3.vehicles.allIDs)
    const userHierarchyTree = useSelector(state => state.containers.v3.userHierarchy.hierarchyTree)

    const onChangeTableTab = (e) => {
        navigate(ROUTES.MODULE_ROUTE[e.target.value])
    }

    let tab = routerLocation.pathname.split('/').pop()

    if (!VAMPanelTab[tab] || tab === 'overall') {
        tab = VAMPanelTab.issues.key
    }

    const locations = Object.values(vehicles)
    ?.map(vehicle => ({ 
        vid: vehicle.vid, 
        location: vehicle.location 
    }))
    ?.filter(vehicle => vehicle.location)

    const init = useRef(false)

    useEffect(() => {
        if(locations?.length && !init.current) {

            // test vamreminders
            locations?.length
            &&
            locations.map(loc => {
                dispatch(REDUX_ACTIONS.v3_vamReminders.get_vam_reminders_thru_vid_request(loc.vid))
                dispatch(REDUX_ACTIONS.v3_vamEntries.get_vam_entry_thru_vid_request(loc.vid))
            })
            
            if(!Object.keys(userHierarchyTree).length){
                dispatch(REDUX_ACTIONS.v3_userHierarchy.user_hierarchy_get_request(user, user.hierCode))
            }

            dispatch(REDUX_ACTIONS.v3_vamLines.get_vam_line_type_by_uid_request(user.uid))
            dispatch(REDUX_ACTIONS.v3_vehicleMaintenances.get_vehicle_maintenance_profiles_request(vids)) 
            dispatch(REDUX_ACTIONS.v3_vehicleMaintenances.get_vehicle_maintenance_states_request(vids))  
            
            init.current = true
        }
    }, [locations])

    return (
        <div className="page-container">
            <Page title="Vehicle Maintenance Management">
                <Radio.Group value={VAMPanelTab[tab].value} buttonStyle="solid" onChange={onChangeTableTab}>
                    {
                        Object.values(VAMPanelTab)
                            .filter(panel => {
                                if (!curUserRole) return false
                                if (!panel.hiddenFrom) return true
                                return !panel.hiddenFrom.includes(curUserRole)
                            })
                            .map(panel =>
                                <Radio.Button key={panel.key} value={panel.value}>
                                    {panel.label}
                                </Radio.Button>
                            )
                    }
                </Radio.Group>

                <div style={{ marginTop: 30 }}>
                    {
                        VAMPanelTab[tab] && VAMPanelTab[tab].component
                    }
                </div>
            </Page>
        </div>
    )
}

const MemorizedVAM = React.memo(VAM);

export default showSecondarySidebar(false)(MemorizedVAM);